import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

type FilteredListingFilterSidebarToggleProps = {
  collapsed: boolean;
  onToggle: () => void;
};

export function FilteredListingFilterSidebarToggle({
  collapsed,
  onToggle,
}: FilteredListingFilterSidebarToggleProps) {
  const { t } = useTranslation();
  const label = collapsed
    ? t('EXPAND_FILTER_SIDEBAR')
    : t('COLLAPSE_FILTER_SIDEBAR');

  return (
    <Tooltip title={label}>
      <Button
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        aria-label={label}
        data-testid="filtered-listing-filter-sidebar-toggle"
        onClick={onToggle}
      />
    </Tooltip>
  );
}
